import React from "react";
import { Row } from "react-bootstrap";
import Select from "react-select";

const HospitalServiceCharges = () => {
  return (
    <>
      <Row>
        <div className="col-xl-6">
          <div className="form-group">
            <label htmlFor="name" className="col-form-label">
              Service Details:
            </label>
            <Select
              // options={
              //   physician &&
              //   physician?.map((physician, i) => ({
              //     value: physician._id,
              //     label: physician?.userId?.name,
              //   }))
              // }
              styles={{
                container: (provided) => ({ ...provided, marginTop: 8 }),
              }}
            />
          </div>
        </div>
      </Row>
    </>
  );
};

export default HospitalServiceCharges;
